/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TokenV2Response } from './TokenV2Response';
import {
    TokenV2ResponseFromJSON,
    TokenV2ResponseFromJSONTyped,
    TokenV2ResponseToJSON,
} from './TokenV2Response';

/**
 * 
 * @export
 * @interface GetTokenV2200ResponseAllOf
 */
export interface GetTokenV2200ResponseAllOf {
    /**
     * 
     * @type {TokenV2Response}
     * @memberof GetTokenV2200ResponseAllOf
     */
    result?: TokenV2Response;
}

/**
 * Check if a given object implements the GetTokenV2200ResponseAllOf interface.
 */
export function instanceOfGetTokenV2200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetTokenV2200ResponseAllOfFromJSON(json: any): GetTokenV2200ResponseAllOf {
    return GetTokenV2200ResponseAllOfFromJSONTyped(json, false);
}

export function GetTokenV2200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTokenV2200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : TokenV2ResponseFromJSON(json['result']),
    };
}

export function GetTokenV2200ResponseAllOfToJSON(value?: GetTokenV2200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': TokenV2ResponseToJSON(value.result),
    };
}

